class CollectionFloatingBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwiper();
  }

  async initSwiper() {
    const isProductPage = document.body.classList.contains('template-product');

    new Swiper(this.querySelector('.collection-floating-bar__slider'), {
      slidesPerView: isProductPage ? 2.5 : 3.2,
      spaceBetween: 4,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 4.8,
        },
        1024: {
          slidesPerView: 7,
        },
      },
    });
  }
}

customElements.define('collection-floating-bar', CollectionFloatingBar);